<!-- <form action="" class="d-flex">
    <input type="search" class="form-control me-2" placeholder="Rechercher" aria-label="Search">
    <button class="btn material-icons" type="submit">search</button>
</form> -->


<!-- <form [formGroup]="formUser" (ngSubmit)="onSubmit()">
  
    <mat-form-field>
        <input matInput placeholder="Login" formControlName="login" >
      </mat-form-field>

      <button type="submit" class="btn btn-primary" style="margin-left: 40px;">Valider</button>


</form> -->

<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <mat-form-field>
        <input matInput formControlName="search">
    </mat-form-field>
    <button class="btn material-icons" type="submit">search</button>
</form>